const BUTTON_GROUP_LABEL_MARGIN = 4;

export { BUTTON_GROUP_LABEL_MARGIN };
